module.exports = __webpack_public_path__ + "img/u820.244344c9.png";